import { Valid } from '../components/types';
import dayjs, { Dayjs } from 'dayjs';

export const convertToValid = (valid: Valid<null | Dayjs>) => ({
  from: valid.from ? dayjs(valid.from) : null,
  to: valid.to ? dayjs(valid.to) : null
});
